import { useState, useEffect } from "react";
import { Modal } from "../../../../components/others/Modal/index";
import { useForm } from "react-hook-form";
import { Input } from "../../../../components/core/Input";
import { PrimaryButton } from "../../../../components/others/ButtonPrimary";
import { OnSubmitTypes, TProps } from "../onSubmitTypes.types";
import LavorisService from "../../../../services/LavorisService";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/combineReducer";
import { useAlert } from "../../../../hooks/useAlert";
import { getErrorMessage } from "../../../../utils";
import { PhoneNumber } from "../../../../components/others/PhoneNumber";

const AddRRHHTurnsCandidate = ({ show, urlTittle, onClose, tableLoading }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold my-6";
  const {
    register,
    reset,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<OnSubmitTypes>({ mode: "all" });

  const [isLoading, setIsLoading] = useState(false);
  const LavorisInstance = LavorisService.getInstance();
  const {showAlert} = useAlert()
  const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);

  const onSubmit = async (data: OnSubmitTypes) => {
    setIsLoading(true);

    const dataToSubmit = {
      ...data,
      companyId: currentCompany.id,
      name: `${data.lastName}, ${data.firstName}`,
      roles: ["CANDIDATE_APPOINTMENTS"],
      password: new Date(Date.now()).toString(),
      phoneNumber: data.phoneNumber
    };
    try {
      const user = await LavorisInstance.User.createUsersByRoleAlias(dataToSubmit);
      if(user.username != data.email) {
        alert(`El usuario de ingreso va a ser ${user.username}`)
      }
      onClose?.();
      tableLoading?.();
    } catch (err) {
      console.log(err);
      showAlert(getErrorMessage({ title: 'Error al crear el rol de RRHH Turnos', err }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    reset();
  }, []);

  return (
    <Modal
      show={show}
      urlTittle={urlTittle}
      modalTitle="Agregar RRHH de Turnos Postulantes"
      onClose={() => onClose?.()}
      titleStyle={styles}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col justify-between align-middle gap-4"
      >
        <Input
          type="text"
          label="Apellido"
          fieldName="lastName"
          register={register}
          required
          error={errors.lastName}
        />
        <Input
          type="text"
          label="Nombre"
          fieldName="firstName"
          register={register}
          required
          error={errors.firstName}
        />

        <Input
          type="email"
          label="Email"
          fieldName="email"
          register={register}
          required
          error={errors.email}
        />

        <PhoneNumber 
          fieldName="phoneNumber"
          label="Teléfono" 
          error={errors.phoneNumber} 
          control={control} 
          required    
        />

        <Input type="text" label="DNI" fieldName="DNI" register={register} />

        <PrimaryButton
          type="submit"
          text="Crear"
          styles="bg-red-500 font-bold text-white mt-8"
          disabled={isLoading}
        />
      </form>
    </Modal>
  );
};

export default AddRRHHTurnsCandidate;
